import {store} from '@/scripts/globals'
import gql from "graphql-tag"
import {apolloClient} from '@/plugins/apollo'
import {getErrorsByExcApolloExc, getProcessedResponseErrorsFlat} from '@/scripts/forms-utils'
import {printSeparated} from "@/scripts/utils";
import {getTrainingParticipantsqty} from "@/scripts/training-utils";
import {hasPermission} from "@/scripts/auth-utils";

export async function fetchUsersOptions(search, filterUsername) {
    let query = gql`
        {
            usersSearch (searchString: ${JSON.stringify(search)}, firstN: 5)  {
                id
                username
            }
        }
    `
    let qRes
    try {
        qRes = await apolloClient.query({query})
    } catch (e) {
        this.submitTrainingErrors = getProcessedResponseErrorsFlat(getErrorsByExcApolloExc(e))
        throw e
    }
    let res = qRes.data['usersSearch']
    if (filterUsername)
        res = res.filter(v => v.username !== filterUsername)
    return res
}


export async function fetchLastParticipantsOptions() {
    let query = gql`
        {
            lastParticipants {
                id
                username
            }
        }
    `
    let qRes
    try {
        qRes = await apolloClient.query({query})
    } catch (e) {
        this.submitTrainingErrors = getProcessedResponseErrorsFlat(getErrorsByExcApolloExc(e))
        throw e
    }
    // noinspection UnnecessaryLocalVariableJS
    let res = qRes.data['lastParticipants']
    return res
}

export default {
    data() {
        return {
            participantOptions: {
                1: [],
                2: [],
                3: [],
                4: [],
                5: [],
                6: [],
                7: [],
                8: []
            },
            participantSelectorPlaceholder: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: ''
            },
            participant: {
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null
            },
            participantCustomName: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: ''
            },
            customPrivacyIds: [],
            customPrivacyOpts: {},
            customPrivacyCounter: 1,
            customPrivacySearchOptions: [],
            privacy: 'Public',
        }
    },
    methods: {
        setParticipantSelectorPlaceholder(focus, seatNum) {
            if (focus)
                this.participantSelectorPlaceholder[seatNum] = ''
            else if (this.participantsQty === 1)
                this.participantSelectorPlaceholder[seatNum] = 'Optional'
            else
                this.participantSelectorPlaceholder[seatNum] = 'Seat ' + seatNum
        },
        setParticipant(val, seatNum) {
            this.onSelectorChanged()
            if (val === null) {
                this.participantCustomName[seatNum] = ''
                this.participant[seatNum] = null
            }
            else if (val.id.startsWith('@')) {
                this.participantCustomName[seatNum] = val.username
                this.participant[seatNum] = null
            } else {
                this.participantCustomName[seatNum] = ''
                this.participant[seatNum] = val
            }
            // noinspection JSIgnoredPromiseFromCall
            this.setBlankSearchParticipantOptions()
        },
        async fetchParticipantOptions(search, loading, seatNum, participant, participantCustomName) {
            if (loading)
                loading(true)
            let selectedParticipantsUsernames = []
            let selectedParticipantsCustomNames = []
            for (let participantSeatNum in participant) {
                // noinspection JSUnfilteredForInLoop
                if (participantSeatNum !== seatNum && participant[participantSeatNum]) {
                    // noinspection JSUnfilteredForInLoop
                    selectedParticipantsUsernames.push(participant[participantSeatNum].username)
                }
                // noinspection JSUnfilteredForInLoop
                if (participantSeatNum !== seatNum && participantCustomName[participantSeatNum]) {
                    // noinspection JSUnfilteredForInLoop
                    selectedParticipantsCustomNames.push(participantCustomName[participantSeatNum])
                }
            }

            let participantOptions
            if (search) {
                participantOptions = await fetchUsersOptions(search)
                participantOptions = participantOptions.filter(option => !selectedParticipantsUsernames.includes(option.username))
                let foundFlag = false
                for (let participant of participantOptions)
                    if (participant.username === search)
                        foundFlag = true
                if (!foundFlag)
                    participantOptions.unshift({username: search, id: '@' + search})
            } else {
                participantOptions = await fetchLastParticipantsOptions()
                participantOptions = participantOptions.filter(option => !selectedParticipantsUsernames.includes(option.username) && !selectedParticipantsCustomNames.includes(option.username))
            }

            this.participantOptions[seatNum] = participantOptions
            if (loading)
                loading(false)
        },
        async fetchCustomPrivacyOptions(search, loading) {
            loading(true)
            this.customPrivacySearchOptions = await fetchUsersOptions(search, store.myUser.username)
            loading(false)
        },
        addCustomPrivacy() {
            this.customPrivacyCounter += 1
            this.customPrivacyOpts[this.customPrivacyCounter] = null
            this.customPrivacyIds.push(this.customPrivacyCounter)
            return this.customPrivacyCounter
        },
        setCustomPrivacyUser(val, customPrivacyId) {
            if (val) {
                this.onSelectorChanged()
                if (!this.customPrivacyOpts[customPrivacyId])
                    this.addCustomPrivacy()
                this.customPrivacyOpts[customPrivacyId] = val
            }
            else {
                this.customPrivacyIds = this.customPrivacyIds.filter(value => value !== customPrivacyId)
                delete this.customPrivacyOpts[customPrivacyId]
                if (!this.customPrivacyIds.length)
                    this.addCustomPrivacy()
            }
        },
        setInitialParticipantPlaceholder() {
            for (let seatNum in [1, 2, 3, 4, 5, 6, 7, 8])
                this.setParticipantSelectorPlaceholder(false, seatNum)
        },
        async setBlankSearchParticipantOptions() {
            for (let seatNum in [1, 2, 3, 4, 5, 6, 7, 8])
                await this.fetchParticipantOptions(null, null, seatNum, this.participant, this.participantCustomName)
        }
    },
    computed: {
        privacyOptions() {
            let res = [
                {label: 'Public', value: 'Public'},
            ]
            let privateOption = {label: 'Private', value: 'Private'};

            if (!hasPermission('create_training_private')) {
                privateOption['props'] = {disabled: true}
                privateOption['label'] = privateOption['label'] + ' - out of your plan'
            }
            res.push(privateOption)
            if (this.participantsQty === 1 && this.participant[1] && this.participant[1].id !== store.myUser.id)
                res.push({label: `Me and ${this.participant[1].username}`, value: 'Participants'})
            else if (this.participantsFlag && this.participantsQty > 1)
                res.push({label: `Me and this boat crew`, value: 'Participants'})
            return res
        },
        participantsQty() {
            return getTrainingParticipantsqty(this)
        },
        participantsFlag() {
            return this.participant[1] || this.participant[2] || this.participant[3] || this.participant[4]
                || this.participant[5] || this.participant[6] || this.participant[7] || this.participant[8]
        },
        seatNums() {
            return[1, 2, 3, 4, 5, 6, 7, 8].slice(0, this.participantsQty)
        }
    },
    watch: {
        participantsFlag(val) {
            if (!val && this.privacy === 'Participants')
                this.privacy = 'Public'
        },
        participantsQty() {
            this.setInitialParticipantPlaceholder()
        }
    }
}